module.exports = __WEBPACK_EXTERNAL_MODULE__34549__;